import React from 'react'
import SummaryView from '../detail/SummaryView'

const RidingView = (props) => {
  const { data: { summary = {} } } = props
  const fieldsOfInterest = ['start_date', 'distance', 'duration', 'avg_speed', 'weighted_avg_watts', 'elevation_gain', 'elevation_loss', 'calories']

  return <SummaryView fieldsOfInterest={fieldsOfInterest} summary={summary} />
}

export default RidingView
